/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type StockPerformanceAnalysisQueryVariables = {|
  stockId: string,
  days?: ?number,
  weeks?: ?number,
  month?: ?number,
  all?: ?boolean,
|};
export type StockPerformanceAnalysisQueryResponse = {|
  +stockPerformanceAnalysis: ?$ReadOnlyArray<?{|
    +updatedPrice: ?number,
    +created: ?any,
  |}>
|};
export type StockPerformanceAnalysisQuery = {|
  variables: StockPerformanceAnalysisQueryVariables,
  response: StockPerformanceAnalysisQueryResponse,
|};
*/


/*
query StockPerformanceAnalysisQuery(
  $stockId: ID!
  $days: Int
  $weeks: Int
  $month: Int
  $all: Boolean
) {
  stockPerformanceAnalysis(stockId: $stockId, weeks: $weeks, days: $days, month: $month, all: $all) {
    updatedPrice
    created
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "all"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "days"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "month"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "stockId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "weeks"
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "all",
        "variableName": "all"
      },
      {
        "kind": "Variable",
        "name": "days",
        "variableName": "days"
      },
      {
        "kind": "Variable",
        "name": "month",
        "variableName": "month"
      },
      {
        "kind": "Variable",
        "name": "stockId",
        "variableName": "stockId"
      },
      {
        "kind": "Variable",
        "name": "weeks",
        "variableName": "weeks"
      }
    ],
    "concreteType": "PastStockHistoryNode",
    "kind": "LinkedField",
    "name": "stockPerformanceAnalysis",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedPrice",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "created",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "StockPerformanceAnalysisQuery",
    "selections": (v5/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "StockPerformanceAnalysisQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "b57a691536cbaa1b96292a02e7654e3d",
    "id": null,
    "metadata": {},
    "name": "StockPerformanceAnalysisQuery",
    "operationKind": "query",
    "text": "query StockPerformanceAnalysisQuery(\n  $stockId: ID!\n  $days: Int\n  $weeks: Int\n  $month: Int\n  $all: Boolean\n) {\n  stockPerformanceAnalysis(stockId: $stockId, weeks: $weeks, days: $days, month: $month, all: $all) {\n    updatedPrice\n    created\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'feb82d6833e10ae602be77b4be97fedf';

module.exports = node;
